import { createContext, useContext, useState } from "react";

const BookingCtx = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const openBooking = (t = "") => { setType(t); setOpen(true); };
  return (
    <BookingCtx.Provider value={{ open, setOpen, type, setType, openBooking }}>
      {children}
    </BookingCtx.Provider>
  );
};

export const useBooking = () => useContext(BookingCtx);
